// import Dashboard from './Dashboard';
import Profile from './Profile';
import Bookmark from './Bookmark';
import Notice from './Notice';
import Footer from '../include/Footer';
import Details from './features/Details';
import Hoteldetails from './features/Hoteldetails';
import '../app_styles/appStyle.css'
import { Route, Routes } from "react-router-dom";

import Location from "./features/Location";
import Hotels from "./features/Hotels";
function App() {
  return (
    
    <section className="CompleteApp">
      <Routes>
        <Route path="/" element={<Location />} />   
        <Route path="/Profile" element={<Profile />} />   
        <Route path="/Bookmark" element={<Bookmark />} />   
        <Route path="/Notice" element={<Notice />} />   
        <Route path="/Location" element={<Location />} />   
        <Route path="/Hotels" element={<Hotels />} />   
        <Route path="/details/:id" element={<Details />} />   
        <Route path="/hoteldetails/:id" element={<Hoteldetails />} />   
      </Routes>
      
      <Footer />
    </section>
  );
}

export default App;
